module.exports = __webpack_public_path__ + "static/media/comfort.6530bc3f.png";